import Vue from 'vue';

import { TeacherContactTypes } from '../constants/teacher-contact-constant';

Vue.mixin({
  data() {
    return {
      teacherContactType: TeacherContactTypes,
    };
  },

  methods: {
    getTeacherContacts() {
      return [
        { name: this.teacherContactType.FACEBOOK, label: this.teacherContactType.FACEBOOK, type: 'checkbox', value: true },
        { name: this.teacherContactType.WHATSAPP, label: this.teacherContactType.WHATSAPP, type: 'checkbox', value: true },
        { name: this.teacherContactType.INSTAGRAM, label: this.teacherContactType.INSTAGRAM, type: 'checkbox', value: true },
        { name: this.teacherContactType.TELEGRAM, label: this.teacherContactType.TELEGRAM, type: 'checkbox', value: true },
        { name: this.teacherContactType.MEET, label: this.teacherContactType.MEET, type: 'checkbox', value: true },
        { name: this.teacherContactType.WEBINAIR, label: this.teacherContactType.WEBINAIR_LABEL, type: 'text', value: '' },
        { name: this.teacherContactType.ADO, label: this.teacherContactType.ADO, type: 'text', value: '' },
        { name: this.teacherContactType.PLATFORM, label: this.teacherContactType.PLATFORM, type: 'text', value: '' },
        { name: this.teacherContactType.OTHER, label: this.teacherContactType.OTHER, type: 'text', value: '' },
      ];
    },
  },
});
